// Campus photo for /colleges/university-of-kansas: CC0 1.0, by Gen. Quon, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AFraser_Hall_(University_of_Kansas).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-kansas/; credited under the photo.
const photo = {
    "slug": "university-of-kansas",
    "alt": "Fraser Hall, a tall limestone building with two red-capped towers and flags, under a clear blue sky at the University of Kansas",
    "src": "/colleges/university-of-kansas/campus-1600.webp",
    "srcSmall": "/colleges/university-of-kansas/campus-800.webp",
    "srcMid": "/colleges/university-of-kansas/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-kansas/og.jpg",
    "title": "Fraser Hall (University of Kansas)",
    "author": "Gen. Quon",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AFraser_Hall_(University_of_Kansas).jpg",
    "read": "2026-10-01"
};

export default photo;
